import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import EncodeRequest from "types/encodeRequest";
import EncodeResponse from "types/encodeResponse";

interface PageState {
  busy: boolean;
  output: string | undefined;
  error: string | undefined;
}

const initialState: PageState = {
  busy: false,
  error: undefined,
  output: undefined,
};

const encodeSlice = createSlice({
  name: "encode",
  initialState,
  reducers: {
    guidGenerate: (state: PageState, action: PayloadAction<EncodeRequest>) => {
      state.busy = true;
      state.output = undefined;
      state.error = undefined;
    },
    guidGenerateSuccess: (
      state: PageState,
      action: PayloadAction<EncodeResponse>
    ) => {
      state.busy = false;
      state.output = action.payload.output;
    },
    guidGenerateFailure: (state: PageState, action: PayloadAction<string>) => {
      state.busy = false;
      state.error = action.payload;
    },
    md5Hash: (state: PageState, action: PayloadAction<EncodeRequest>) => {
      state.busy = true;
      state.output = undefined;
      state.error = undefined;
    },
    md5HashSuccess: (
      state: PageState,
      action: PayloadAction<EncodeResponse>
    ) => {
      state.busy = false;
      state.output = action.payload.output;
    },
    md5HashFailure: (state: PageState, action: PayloadAction<string>) => {
      state.busy = false;
      state.error = action.payload;
    },
    urlEncode: (state: PageState, action: PayloadAction<EncodeRequest>) => {
      state.busy = true;
      state.output = undefined;
      state.error = undefined;
    },
    urlEncodeSuccess: (
      state: PageState,
      action: PayloadAction<EncodeResponse>
    ) => {
      state.busy = false;
      state.output = action.payload.output;
    },
    urlEncodeFailure: (state: PageState, action: PayloadAction<string>) => {
      state.busy = false;
      state.error = action.payload;
    },
    urlDecode: (state: PageState, action: PayloadAction<EncodeRequest>) => {
      state.busy = true;
      state.output = undefined;
      state.error = undefined;
    },
    urlDecodeSuccess: (
      state: PageState,
      action: PayloadAction<EncodeResponse>
    ) => {
      state.busy = false;
      state.output = action.payload.output;
    },
    urlDecodeFailure: (state: PageState, action: PayloadAction<string>) => {
      state.busy = false;
      state.error = action.payload;
    },
    base64Encode: (state: PageState, action: PayloadAction<EncodeRequest>) => {
      state.busy = true;
      state.output = undefined;
      state.error = undefined;
    },
    base64EncodeSuccess: (
      state: PageState,
      action: PayloadAction<EncodeResponse>
    ) => {
      state.busy = false;
      state.output = action.payload.output;
    },
    base64EncodeFailure: (state: PageState, action: PayloadAction<string>) => {
      state.busy = false;
      state.error = action.payload;
    },
    base64Decode: (state: PageState, action: PayloadAction<EncodeRequest>) => {
      state.busy = true;
      state.output = undefined;
      state.error = undefined;
    },
    base64DecodeSuccess: (
      state: PageState,
      action: PayloadAction<EncodeResponse>
    ) => {
      state.busy = false;
      state.output = action.payload.output;
    },
    base64DecodeFailure: (state: PageState, action: PayloadAction<string>) => {
      state.busy = false;
      state.error = action.payload;
    },
  },
});

export const {
  guidGenerateSuccess,
  guidGenerateFailure,
  urlDecodeSuccess,
  urlDecodeFailure,
  urlEncodeSuccess,
  urlEncodeFailure,
  base64EncodeSuccess,
  base64EncodeFailure,
  base64DecodeSuccess,
  base64DecodeFailure,
  md5HashSuccess,
  md5HashFailure,
} = encodeSlice.actions;

export default encodeSlice;
